import React from "react";
import ContasCards from "./ContasAPagar/ContasCards";
import Card from "../../components/page/Card";
import ContasFiltros from "./ContasAPagar/ContasFiltros";
import { adicionarDias, hoje, mesAtual } from "../../helpers/mesesHelper";
import ImpostosDataTable from "./ContasAPagar/Impostos/ImpostosDataTable";
import MensalidadeDataTable from "./ContasAPagar/Mensalidade/MensalidadeDataTable";
import ProLaboreDataTable from "./ContasAPagar/ProLabore/ProLaboreDataTable";
import FolhaPagamentoDataTable from "./ContasAPagar/FolhaPagamento/FolhaPagamentoDataTable";
import NovoImpostoModal from "./ContasAPagar/Impostos/NovoImpostoModal";
import NovoProLaboreModal from "./ContasAPagar/ProLabore/NovoProLaboreModal";
import NovaFolhaPagamentoModal from "./ContasAPagar/FolhaPagamento/NovaFolhaPagamentoModal";
import DocumentoModal from "../../components/Common/DocumentoModal";
import PagarImpostoModal from "./ContasAPagar/Impostos/PagarImpostoModal";
import OptionsSwal from "../../components/Swal/optionsSwal";
import CommonSwal from "../../components/Swal/commonSwal";
import ErrorSwal from "../../components/Swal/errorSwal";
import SubstituirImpostoModal from "./ContasAPagar/Impostos/SubstituirImpostoModal";
import SubstituirHonorarioModal from "./ContasAPagar/Mensalidade/SubstituirHonorarioModal";
import SolicitarRecalculoModal from "./ContasAPagar/Impostos/SolicitarRecalculoModal";
import HistoricoModal from "./ContasAPagar/Impostos/HistoricoModal";
import { AppContext } from "../../contexts/AppContext";
import useApi from "../../hooks/useApi";
import contasAPagarApiClient from "../../api/contasAPagar";
import Badge from "../../components/Common/Badge";
import ColaboradoresApiClient from "../../api/colaboradores";
import CommonsApiClient from "../../api/commons";
import Validation from "../../helpers/Validation";
import TabList from "../../components/Tab/TabList";
import TabButton from "../../components/Tab/TabButton";
import TabContent from "../../components/Tab/TabContent";
import TabPane from "../../components/Tab/TabPane";
import DownloadMassaModal from "./ContasAPagar/DownloadMassaModal";

function ContasAPagar() {
  const [cards, setCards] = React.useState({});
  const [tabAtiva, setTabAtiva] = React.useState(true);
  const [filtros, setFiltros] = React.useState({
    mes: mesAtual,
    ano: hoje.getFullYear(),
  });
  const [socios, setSocios] = React.useState([]);
  const [colaboradores, setColaboradores] = React.useState([]);
  const [impostos, setImpostos] = React.useState([]);
  const [impostosAtrasados, setImpostosAtrasados] = React.useState([]);
  const [honorarios, setHonorarios] = React.useState([]);
  const [proLabores, setProLabores] = React.useState([]);
  const [folhaPagamento, setFolhaPagamento] = React.useState([]);
  const [values, setValues] = React.useState({});
  const [checkboxesMarcadosFP, setCheckboxesMarcadosFP] = React.useState([]);
  const [checkboxesMarcadosPL, setCheckboxesMarcadosPL] = React.useState([]);
  const [novoImpostoModal, setNovoImpostoModal] = React.useState(false);
  const [novoProLaboreModal, setNovoProLaboreModal] = React.useState(false);
  const [documentoModal, setDocumentoModal] = React.useState(false);
  const [pagarImpostoModal, setPagarImpostoModal] = React.useState(false);
  const [solicitarRecalculoModal, setSolicitarRecalculoModal] =
    React.useState(false);
  const [substituirHonorarioModal, setSubstituirHonorarioModal] =
    React.useState(false);
  const [substituirImpostoModal, setSubstituirImpostoModal] =
    React.useState(false);
  const [novaFolhaPagamentoModal, setNovaFolhaPagamentoModal] =
    React.useState(false);
  const [historicoModal, setHistoricoModal] = React.useState(false);
  const [anoInicial, setAnoInicial] = React.useState(2018);
  const [downloadMassaModal, setDownloadMassaModal] = React.useState(false);
  const anoFinal = hoje.getFullYear() + 1;
  const { session } = React.useContext(AppContext);

  const getContasCb = React.useCallback(
    (mes = null, ano = null) => {
      return contasAPagarApiClient.getContas(
        session.empresa.replace(/E/gi, ""),
        {
          mes: mes ? mes : filtros.mes,
          ano: ano ? ano : filtros.ano,
        }
      );
    },
    [filtros.ano, filtros.mes, session.empresa]
  );

  const getImpostosCb = React.useCallback(
    (mes = null, ano = null) => {
      return contasAPagarApiClient.getImpostos(
        session.empresa.replace(/E/gi, ""),
        {
          mes: mes ? mes : filtros.mes,
          ano: ano ? ano : filtros.ano,
        }
      );
    },
    [filtros.ano, filtros.mes, session.empresa]
  );

  const getHonorariosCb = React.useCallback(
    (ano = null) => {
      return contasAPagarApiClient.getHonorarios(
        session.empresa.replace(/E/gi, ""),
        {
          ano: ano ? ano : filtros.ano,
        }
      );
    },
    [filtros.ano, session.empresa]
  );

  const getProlaboreCb = React.useCallback(
    (mes = null, ano = null) => {
      return contasAPagarApiClient.getProlabore(
        session.empresa.replace(/E/gi, ""),
        {
          mes: mes ? mes : filtros.mes,
          ano: ano ? ano : filtros.ano,
        }
      );
    },
    [filtros.ano, filtros.mes, session.empresa]
  );

  const getFolhaPagamentoCb = React.useCallback(
    (mes = null, ano = null) => {
      return contasAPagarApiClient.getFolhaPagamento(
        session.empresa.replace(/E/gi, ""),
        {
          mes: mes ? mes : filtros.mes,
          ano: ano ? ano : filtros.ano,
        }
      );
    },
    [filtros.ano, filtros.mes, session.empresa]
  );

  const { request: getContas, data: contasResponse } = useApi(getContasCb);
  const { request: getImpostos, data: impostosResponse } =
    useApi(getImpostosCb);
  const { request: getHonorarios, data: honorariosResponse } =
    useApi(getHonorariosCb);
  const { request: getProlabore, data: prolaboreResponse } =
    useApi(getProlaboreCb);
  const { request: getFolhaPagamento, data: folhaPagamentoResponse } =
    useApi(getFolhaPagamentoCb);
  const { request: getImpostosAtrasados, data: impostosAtrasadosResponse } =
    useApi(contasAPagarApiClient.getImpostos);
  const { request: getSocios, data: sociosResponse } = useApi(
    ColaboradoresApiClient.getSocios
  );
  const { request: getColaboradores, data: colaboradoresResponse } = useApi(
    ColaboradoresApiClient.getColaboradores
  );
  const documentoRouteApi = useApi(CommonsApiClient.documentoRoute);
  const postImpostosApi = useApi(contasAPagarApiClient.postImpostos);
  const postProlaboreApi = useApi(contasAPagarApiClient.postProlabore);
  const postFolhaPagamentoApi = useApi(
    contasAPagarApiClient.postFolhaPagamento
  );
  const deleteImpostosApi = useApi(contasAPagarApiClient.deleteImposto);
  const deleteProlaboreApi = useApi(contasAPagarApiClient.deleteProlabore);
  const deleteFolhaPagamentoApi = useApi(
    contasAPagarApiClient.deleteFolhaPagamento
  );
  const putImpostosApi = useApi(contasAPagarApiClient.putImpostos);
  const putProlaboreApi = useApi(contasAPagarApiClient.putProlabore);
  const putFolhaPagamentoApi = useApi(contasAPagarApiClient.putFolhaPagamento);
  const getInformacoesArquivoApi = useApi(
    contasAPagarApiClient.getInformacoesArquivo,
    false
  );
  const substituirImpostoApi = useApi(contasAPagarApiClient.substituirImposto);
  const substituirHonorarioApi = useApi(
    contasAPagarApiClient.substituirHonorario
  );
  const downloadMassaApi = useApi(contasAPagarApiClient.downloadMassa);
  const excluirHistoricoApi = useApi(contasAPagarApiClient.excluirHistorico);
  const recalcularImpostoAutomaticoApi = useApi(
    contasAPagarApiClient.recalcularImpostoAutomatico
  );
  const solicitarRecalculoImpostoApi = useApi(
    contasAPagarApiClient.solicitarRecalculoImposto
  );

  //Busca dados dos cards ao renderizar tela
  React.useEffect(() => {
    if (session.empresa) getContas();
  }, [getContas, session.empresa]);

  //Busca dados dos impostos ao renderizar tela
  React.useEffect(() => {
    if (session.empresa) getImpostos();
  }, [getImpostos, session.empresa]);

  //Busca dados dos honorarios ao renderizar tela
  React.useEffect(() => {
    if (session.empresa) getHonorarios();
  }, [getHonorarios, session.empresa]);

  //Busca dados dos honorarios ao renderizar tela
  React.useEffect(() => {
    if (session.empresa) getProlabore();
  }, [getProlabore, session.empresa]);

  //Busca dados das folhas de pagamento ao renderizar tela
  React.useEffect(() => {
    if (session.empresa) getFolhaPagamento();
  }, [getFolhaPagamento, session.empresa]);

  //Busca dados dos impostos atrasados ao renderizar tela
  React.useEffect(() => {
    if (session.empresa)
      getImpostosAtrasados(session.empresa.replace(/E/gi, ""), {
        tipo: "2",
      });
  }, [getImpostosAtrasados, session.empresa]);

  //Busca dados dos sócios ao renderizar tela
  React.useEffect(() => {
    if (session.empresa) getSocios(session.empresa.replace(/E/gi, ""));
  }, [getSocios, session.empresa]);

  //Busca dados dos colaboradores ao renderizar tela
  React.useEffect(() => {
    if (session.empresa) getColaboradores(session.empresa.replace(/E/gi, ""));
  }, [getColaboradores, session.empresa]);

  //Define o retorno da api no valor do estado
  React.useEffect(() => {
    if (contasResponse) setCards(contasResponse);
  }, [contasResponse]);

  //Define o retorno da api no valor das linhas
  React.useEffect(() => {
    if (impostosResponse) setImpostos(impostosResponse?.impostos);
  }, [impostosResponse]);

  //Define o retorno da api no valor das linhas
  React.useEffect(() => {
    if (honorariosResponse) setHonorarios(honorariosResponse?.honorarios);
  }, [honorariosResponse]);

  //Define o retorno da api no valor das linhas
  React.useEffect(() => {
    if (prolaboreResponse) setProLabores(prolaboreResponse?.prolabore);
  }, [prolaboreResponse]);

  //Define o retorno da api no valor das linhas
  React.useEffect(() => {
    if (folhaPagamentoResponse)
      setFolhaPagamento(folhaPagamentoResponse?.folha_pagamento);
  }, [folhaPagamentoResponse]);

  //Define o retorno da api no valor das linhas
  React.useEffect(() => {
    if (impostosAtrasadosResponse)
      setImpostosAtrasados(impostosAtrasadosResponse?.impostos);
  }, [impostosAtrasadosResponse]);

  //Define o retorno da api no valor do estado
  React.useEffect(() => {
    if (sociosResponse) setSocios(sociosResponse);
  }, [sociosResponse]);

  //Define o retorno da api no valor do estado
  React.useEffect(() => {
    if (colaboradoresResponse) {
      setColaboradores([{ nome: "Geral", uid: "-" }, ...colaboradoresResponse]);
    }
  }, [colaboradoresResponse]);

  //Define a tab ativa pelos parâmetros da url
  React.useEffect(() => {
    const tab = new URLSearchParams(window.location.search).get("tab");
    const tabs = ["impostos", "honorarios", "prolabore", "folhapagamento"];
    setTabAtiva(tabs.includes(tab) ? tab : "impostos");
  }, []);

  //Define o ano mínimo
  React.useEffect(() => {
    if (session && session?.inicio_prestacao)
      setAnoInicial(session.inicio_prestacao);
  }, [session]);

  const togNovoImpostoModal = () => {
    setValues({});
    setNovoImpostoModal(true);
  };

  const togNovoProLaboreModal = () => {
    setValues({});
    setNovoProLaboreModal(true);
  };

  const togNovaFolhaPagamentoModal = () => {
    setValues({});
    setNovaFolhaPagamentoModal(true);
  };

  const togPagarImpostoModal = (uid, pago, valor) => {
    setValues({
      uid,
      pago,
      valor,
      dataPagamento: hoje.toISOString().split("T")[0],
    });
    setPagarImpostoModal(true);
  };

  const togSolicitarRecalculoModal = (uid, categoria, mes_referencia) => {
    setValues({ uid, categoria, mes_referencia });
    setSolicitarRecalculoModal(true);
  };

  const togSubstituirImpostoModal = (uid) => {
    setValues({ uid });
    setSubstituirImpostoModal(true);
  };

  const togSubstituirHonorarioModal = (uid) => {
    setValues({ uid });
    setSubstituirHonorarioModal(true);
  };

  const toghistoricoModal = (
    historico,
    documentos,
    descricao,
    categoria,
    uid
  ) => {
    setValues({ historico, documentos, descricao, categoria, uid });
    setHistoricoModal(true);
  };

  const visualizarDocumento = async (
    caminho,
    imposto = false,
    uid = "",
    status = ""
  ) => {
    if (imposto && status === "ENVIADO" && session?.codigo !== "99") {
      const viewResponse = await putImpostosApi.request(
        session?.empresa.replace(/E/gi, ""),
        {
          uid,
          tipo_status: 1,
          status: "VISUALIZADO",
        }
      );
      if (!viewResponse) return;
      getImpostos();
      getImpostosAtrasados(session.empresa.replace(/E/gi, ""), {
        tipo: "2",
      });
      getContas();
    }
    const response = await documentoRouteApi.request(caminho, {
      ext: "pdf",
      type: "visualizar",
    });
    if (!response) return;
    const pdfBlob = new Blob([response], { type: "application/pdf" });
    const documentUrl = URL.createObjectURL(pdfBlob);
    setValues({ documento: documentUrl });
    setDocumentoModal(true);
  };

  const excluirImposto = async (uid) => {
    OptionsSwal({
      title: "Tem certeza que deseja excluir este arquivo?",
    }).then(async (response) => {
      if (response.isConfirmed) {
        const response = await deleteImpostosApi.request(
          session?.empresa.replace(/E/gi, ""),
          uid
        );
        if (!response) return;
        CommonSwal({ title: "Arquivo excluído com sucesso!", icon: "success" });
        getImpostos();
        getImpostosAtrasados(session.empresa.replace(/E/gi, ""), {
          tipo: "2",
        });
        getContas();
      }
    });
  };

  const excluirFolhaPagamento = async (uid) => {
    OptionsSwal({
      title: "Tem certeza que deseja excluir este arquivo?",
    }).then(async (response) => {
      if (response.isConfirmed) {
        const response = await deleteFolhaPagamentoApi.request(
          session?.empresa.replace(/E/gi, ""),
          uid
        );
        if (!response) return;
        CommonSwal({ title: "Arquivo excluído com sucesso!", icon: "success" });
        getFolhaPagamento();
        getContas();
      }
    });
  };

  const excluirProLabore = async (uid) => {
    OptionsSwal({
      title: "Tem certeza que deseja excluir este arquivo?",
    }).then(async (response) => {
      if (response.isConfirmed) {
        const response = await deleteProlaboreApi.request(
          session?.empresa.replace(/E/gi, ""),
          uid
        );
        if (!response) return;
        CommonSwal({ title: "Arquivo excluído com sucesso!", icon: "success" });
        getProlabore();
        getContas();
      }
    });
  };

  const pagarProLabore = async (uid, pago) => {
    OptionsSwal({
      title: "Tem certeza que deseja alterar a situação?",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const response = await putProlaboreApi.request(
          session?.empresa.replace(/E/gi, ""),
          { uid, status: pago ? "PENDENTE" : "PAGO" }
        );
        if (!response) return;
        CommonSwal({
          title: "Situação alterada com sucesso!",
          icon: "success",
        });
        getProlabore();
        getContas();
      }
    });
  };

  const pagarFolhaPagamento = async (uid, pago) => {
    OptionsSwal({
      title: "Tem certeza que deseja alterar a situação?",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const response = await putFolhaPagamentoApi.request(
          session?.empresa.replace(/E/gi, ""),
          { uid, status: pago ? "PENDENTE" : "PAGO" }
        );
        if (!response) return;
        CommonSwal({
          title: "Situação alterada com sucesso!",
          icon: "success",
        });
        getFolhaPagamento();
        getContas();
      }
    });
  };

  const pagarImposto = async () => {
    const formData = new FormData();
    formData.append("uid", values?.uid);
    formData.append("tipo_status", 2);
    formData.append("status", 1);
    formData.append("valor_pago", values?.valor);
    formData.append("data_pagamento", values?.dataPagamento);

    if (Validation.verificarForm(formData))
      return ErrorSwal({
        text: "Favor preencher todos os dados obrigatórios.",
      });

    const response = await putImpostosApi.request(
      session?.empresa.replace(/E/gi, ""),
      formData
    );
    if (!response) return;
    setPagarImpostoModal(false);
    getImpostos();
    getImpostosAtrasados(session.empresa.replace(/E/gi, ""), {
      tipo: "2",
    });
    getContas();
  };

  const cancelarPagamentoImposto = async () => {
    const formData = new FormData();
    formData.append("uid", values?.uid);
    formData.append("tipo_status", 2);
    formData.append("status", 0);

    const response = await putImpostosApi.request(
      session?.empresa.replace(/E/gi, ""),
      formData
    );
    if (!response) return;
    setPagarImpostoModal(false);
    getImpostos();
    getImpostosAtrasados(session.empresa.replace(/E/gi, ""), {
      tipo: "2",
    });
    getContas();
  };

  const cancelarRecalculo = async (uid) => {
    const viewResponse = await putImpostosApi.request(
      session?.empresa.replace(/E/gi, ""),
      {
        uid,
        tipo_status: 1,
        status: "VISUALIZADO",
      }
    );
    if (!viewResponse) return;
    CommonSwal({
      title: "Solicitação de recálculo cancelada com sucesso",
      icon: "success",
    });
    getImpostos();
    getImpostosAtrasados(session.empresa.replace(/E/gi, ""), {
      tipo: "2",
    });
    getContas();
  };

  const downloadDocumento = async (
    caminho,
    descricao,
    imposto = false,
    uid = "",
    status = ""
  ) => {
    if (imposto && status !== "VISUALIZADO" && session?.codigo !== "99") {
      const viewResponse = await putImpostosApi.request(
        session?.empresa.replace(/E/gi, ""),
        {
          uid,
          tipo_status: 1,
          status: "VISUALIZADO",
        }
      );
      if (!viewResponse) return;
      getImpostos();
      getImpostosAtrasados(session.empresa.replace(/E/gi, ""), {
        tipo: "2",
      });
      getContas();
    }
    const response = await documentoRouteApi.request(caminho, {
      ext: "pdf",
      type: "download",
    });
    if (!response) return;
    const blob = new Blob([response]);
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `${descricao}.pdf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  };

  const salvaImposto = async () => {
    const formData = new FormData();
    formData.append("descricao", values?.descricao);
    formData.append("categoria", values?.categoria);
    formData.append("valor", values?.valor);
    formData.append("data_vencimento", values?.vencimento);
    formData.append("arquivo", values?.arquivo);

    if (Validation.verificarForm(formData))
      return ErrorSwal({
        text: "Favor preencher todos os dados obrigatórios.",
      });

    if (
      Validation.validarDataMinMax(
        values?.vencimento,
        anoInicial + "-01-01",
        anoFinal + "-12-31"
      )
    )
      return ErrorSwal({
        text: "Favor preencher com uma data válida.",
      });

    if (values?.valor < 1)
      return ErrorSwal({
        text: "Valor deve ser superior a R$1,00.",
      });

    formData.append("codigo_barras", values?.codigoBarras);

    const response = await postImpostosApi.request(
      session?.empresa.replace(/E/gi, ""),
      formData
    );
    if (!response) return;
    CommonSwal({ title: "Imposto salvo com sucesso!", icon: "success" });
    setNovoImpostoModal(false);
    getImpostos();
    getImpostosAtrasados(session.empresa.replace(/E/gi, ""), {
      tipo: "2",
    });
    getContas();
  };

  const salvaProlabore = async () => {
    const formData = new FormData();
    formData.append("socios", values?.socio);
    formData.append("valor_liquido", values?.valor);
    formData.append("tipo_retirada", values?.tipoRetirada);
    formData.append("mesano", values?.mesReferencia);
    formData.append("mes_pagamento", values?.mesPagamento);
    formData.append("arquivo", values?.arquivo);

    if (Validation.verificarForm(formData))
      return ErrorSwal({
        text: "Favor preencher todos os dados obrigatórios.",
      });

    if (
      Validation.validarDataMinMax(
        values?.mesReferencia + "-01",
        anoInicial + "-01-01",
        anoFinal + "-12-31"
      )
    )
      return ErrorSwal({
        text: "Favor preencher com uma data válida.",
      });

    if (values?.valor < 1)
      return ErrorSwal({
        text: "Valor deve ser superior a R$1,00.",
      });

    const response = await postProlaboreApi.request(
      session?.empresa.replace(/E/gi, ""),
      formData
    );
    if (!response) return;
    CommonSwal({ title: "Pró-labore salvo com sucesso!", icon: "success" });
    setNovoProLaboreModal(false);
    getProlabore();
    getContas();
  };

  const salvaFolhaPagamento = async () => {
    const formData = new FormData();
    formData.append("uid_colaborador", values?.colaborador);
    formData.append("tipo_verba", values?.verba);
    formData.append("mes_referencia", values?.mesReferencia);
    formData.append("data_pagamento", values?.pagamento);
    formData.append("valor_liquido", values?.valor);
    formData.append("arquivo", values?.arquivo);

    if (Validation.verificarForm(formData))
      return ErrorSwal({
        text: "Favor preencher todos os dados obrigatórios.",
      });

    if (
      Validation.validarDataMinMax(
        values?.mesReferencia + "-01",
        anoInicial + "-01-01",
        anoFinal + "-12-31"
      )
    )
      return ErrorSwal({
        text: "Favor preencher com uma data válida.",
      });

    if (values?.valor < 1)
      return ErrorSwal({
        text: "Valor deve ser superior a R$1,00.",
      });

    if (values?.colaborador === "-") formData.delete("uid_colaborador");

    const response = await postFolhaPagamentoApi.request(
      session?.empresa.replace(/E/gi, ""),
      formData
    );
    if (!response) return;
    CommonSwal({
      title: "Folha de pagamento salva com sucesso!",
      icon: "success",
    });
    setNovaFolhaPagamentoModal(false);
    getFolhaPagamento();
    getContas();
  };

  const solicitarRecalculo = async () => {
    const formData = new FormData();
    formData.append("uid", values?.uid);
    formData.append("data_vencimento", values?.vencimento);
    formData.append("nome_solicitante", session?.who);
    formData.append("email_solicitante", session?.email);

    if (Validation.verificarForm(formData))
      return ErrorSwal({
        text: "Favor preencher todos os dados obrigatórios.",
      });

    if (
      Validation.validarDataMinMax(values?.vencimento, adicionarDias(2), null)
    )
      return ErrorSwal({
        text: "Favor preencher uma data válida.",
      });

    const response = await solicitarRecalculoImpostoApi.request(
      session?.empresa.replace(/E/gi, ""),
      formData
    );

    if (!response) return;
    setSolicitarRecalculoModal(false);
    CommonSwal({
      title: "Recálculo solicitado com sucesso",
      html: "<p style='color: #74788d!important; font-weight: 500 !important; float: left !important;font-family: var(--bs-font-sans-serif) !important;font-size: 0.9rem !important;line-height: 1.5 !important;'>Vamos providenciar o recálculo da guia solicitada! Essa solicitação pode levar até 24 horas, para ser disponibilizada! Reforçamos sobre o custo adicional associado a esta solicitação, conforme a atualização do contrato!</p>",
      icon: "success",
    });
    getImpostos();
    getImpostosAtrasados(session.empresa.replace(/E/gi, ""), {
      tipo: "2",
    });
    getContas();
  };

  const solicitarRecalculoAutomatico = async () => {
    const formData = new FormData();
    formData.append("documento", values?.uid);
    formData.append("data_vencimento", values?.vencimento);
    formData.append("solicitante_email", session?.email);
    formData.append("solicitante", session?.nome || session?.who);

    if (Validation.verificarForm(formData))
      return ErrorSwal({
        text: "Favor preencher todos os dados obrigatórios.",
      });

    if (
      Validation.validarDataMinMax(values?.vencimento, adicionarDias(2), null)
    )
      return ErrorSwal({
        text: "Favor preencher uma data válida.",
      });

    const response = await recalcularImpostoAutomaticoApi.request(
      session?.empresa.replace(/E/gi, ""),
      formData
    );

    if (!response) return;
    if (response?.status == "INFO") {
      CommonSwal({
        title: response?.message,
        icon: "info",
      });
    } else {
      CommonSwal({
        title: "Recálculo solicitado com sucesso",
        html: "<p style='color: #74788d!important; font-weight: 500 !important; float: left !important;font-family: var(--bs-font-sans-serif) !important;font-size: 0.9rem !important;line-height: 1.5 !important;'>Vamos providenciar o recálculo da guia solicitada! Essa solicitação pode levar até 24 horas, para ser disponibilizada! Reforçamos sobre o custo adicional associado a esta solicitação, conforme a atualização do contrato!</p>",
        icon: "success",
      });
    }
    setSolicitarRecalculoModal(false);
    getImpostos();
    getImpostosAtrasados(session.empresa.replace(/E/gi, ""), {
      tipo: "2",
    });
    getContas();
  };

  const getDadosArquivo = async ({ arquivo = null, categoria = null }) => {
    const formData = new FormData();
    formData.append("categoria", categoria ? categoria : values?.categoria);
    formData.append("arquivo", arquivo ? arquivo : values?.arquivo);

    if (Validation.verificarForm(formData)) return;

    const response = await getInformacoesArquivoApi.request(
      session?.empresa.replace(/E/gi, ""),
      formData
    );
    if (!response) return;
    setValues({
      ...values,
      vencimento: response.vencimento
        ? response.vencimento
        : values?.vencimento,
      valor: response.valor ? response.valor : values?.valor,
      codigoBarras: response.codigo_barras
        ? response.codigo_barras
        : values?.codigoBarras,
      categoria: categoria ? categoria : values?.categoria,
      arquivo: arquivo ? arquivo : values?.arquivo,
    });
  };

  const substituirImposto = async () => {
    const formData = new FormData();
    formData.append("valor", values?.valor);
    formData.append("data_vencimento", values?.vencimento);
    formData.append("arquivo", values?.arquivo);

    if (Validation.verificarForm(formData))
      return ErrorSwal({
        text: "Favor preencher todos os dados obrigatórios.",
      });

    formData.append("codigo_barras", values?.codigoBarras || "");

    const response = await substituirImpostoApi.request(
      session.empresa.replace(/E/gi, ""),
      values?.uid,
      formData
    );
    if (!response) return;
    CommonSwal({
      title: "Arquivo salvo",
      icon: "success",
    });
    setSubstituirImpostoModal(false);
    getImpostos();
    getImpostosAtrasados(session.empresa.replace(/E/gi, ""), {
      tipo: "2",
    });
    getContas();
  };

  const substituirHonorario = async () => {
    const formData = new FormData();
    formData.append("data_vencimento", values?.vencimento);

    if (Validation.verificarForm(formData))
      return ErrorSwal({
        text: "Favor preencher todos os dados obrigatórios.",
      });

    const response = await substituirHonorarioApi.request(
      session.empresa.replace(/E/gi, ""),
      values?.uid,
      formData
    );
    if (!response) return;
    CommonSwal({
      title: "Mensalidade substituída com sucesso",
      icon: "success",
    });
    setSubstituirHonorarioModal(false);
    getHonorarios();
    getContas();
  };

  const togDownloadMassaModal = (tipo) => {
    setValues({ tipo, opcao_download: true });
    setDownloadMassaModal(true);
  };

  const downloadMassa = async () => {
    const formData = new FormData();

    if (values.opcao_download) {
      if (values.tipo === "Prolabore") {
        if (checkboxesMarcadosPL.length === 0)
          return ErrorSwal({
            text: "Nenhuma cobrança marcada.",
          });

        checkboxesMarcadosPL.forEach((uid, index) => {
          formData.append(`documentos[${index}][id]`, uid);
        });
      } else {
        if (checkboxesMarcadosFP.length === 0)
          return ErrorSwal({
            text: "Nenhuma cobrança marcada.",
          });

        checkboxesMarcadosFP.forEach((uid, index) => {
          formData.append(`documentos[${index}][id]`, uid);
        });
      }
    } else {
      const idsParaAppend =
        values.tipo === "Prolabore"
          ? proLabores.map((linha) => linha.uid)
          : folhaPagamento.map((linha) => linha.uid);

      if (idsParaAppend.length === 0) {
        return ErrorSwal({
          text: "Não existem cobranças para realizar download.",
        });
      }

      idsParaAppend.forEach((uid, index) => {
        formData.append(`documentos[${index}][id]`, uid);
      });
    }
    formData.append("tipo", values.tipo);

    const response = await downloadMassaApi.request(formData);
    if (!response) return;
    const blob = new Blob([response], { type: "application/zip" });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `${values.tipo === "Prolabore" ? "Pro-labores" : "Folhas de pagamento"} - ${hoje
      .toLocaleDateString("pt-BR")
      .replace(/\//g, "-")}.zip`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
    setDownloadMassaModal(false);
  };

  const excluirDocumento = (index) => {
    OptionsSwal({
      icon: "warning",
      title: "Tem certeza que deseja excluir este recálculo?",
      text: "Ao fazer isto, a quantidade de recálculos a serem cobrados do cliente reduzirá em 1.",
    }).then(async (res) => {
      if (res.isConfirmed) {
        const documentosAtualizados = values.documentos.map((doc, i) =>
          i === index ? { ...doc, ativo: 0 } : doc
        );
        const newJson = JSON.stringify(documentosAtualizados);
        const newHistorico = {
          ...values.historico,
          documentos: newJson,
        };

        const formData = new FormData();
        formData.append("historico", JSON.stringify(newHistorico));
        const response = await excluirHistoricoApi.request(
          session.empresa.replace(/E/gi, ""),
          values?.uid,
          formData
        );
        if (!response) return;
        setValues({
          ...values,
          documentos: documentosAtualizados,
        });
        CommonSwal({
          title: "Histórico atualizado com sucesso",
          icon: "success",
        });
        getImpostos();
        getImpostosAtrasados(session.empresa.replace(/E/gi, ""), {
          tipo: "2",
        });
      }
    });
  };

  return (
    <>
      <div className="row">
        <ContasCards cards={cards} />
        <Card>
          <ContasFiltros filtrosHook={{ filtros, setFiltros }} />
          <TabList>
            <TabButton
              href="impostos"
              ativo={tabAtiva === "impostos"}
              onClick={() => {
                setTabAtiva("impostos");
              }}
            >
              <>
                Impostos{" "}
                {cards?.impostos_total > 0 ? (
                  cards?.impostos_em_aberto > 0 ? (
                    <Badge color="danger" rounded>
                      {cards?.impostos_em_aberto}
                    </Badge>
                  ) : (
                    <Badge color="success" rounded>
                      ✔
                    </Badge>
                  )
                ) : (
                  ""
                )}
              </>
            </TabButton>
            <TabButton
              href="mensalidade"
              ativo={tabAtiva === "honorarios"}
              onClick={() => {
                setTabAtiva("honorarios");
              }}
            >
              <>
                Mensalidade{" "}
                {cards?.honorarios_total > 0 ? (
                  cards?.honorarios_em_aberto > 0 ? (
                    <Badge color="danger" rounded>
                      {cards?.honorarios_em_aberto}
                    </Badge>
                  ) : (
                    <Badge color="success" rounded>
                      ✔
                    </Badge>
                  )
                ) : (
                  ""
                )}
              </>
            </TabButton>
            <TabButton
              href="proLabore"
              ativo={tabAtiva === "prolabore"}
              onClick={() => {
                setTabAtiva("prolabore");
              }}
            >
              <>
                Pró-labore{" "}
                {cards?.prolabore_total > 0 ? (
                  cards?.prolabore_em_aberto > 0 ? (
                    <Badge color="danger" rounded>
                      {cards?.prolabore_em_aberto}
                    </Badge>
                  ) : (
                    <Badge color="success" rounded>
                      ✔
                    </Badge>
                  )
                ) : (
                  ""
                )}
              </>
            </TabButton>
            <TabButton
              href="folhaDePagamento"
              ativo={tabAtiva === "folhapagamento"}
              onClick={() => {
                setTabAtiva("folhapagamento");
              }}
            >
              <>
                Folha de pagamento{" "}
                {cards?.folha_pagamento_total > 0 ? (
                  cards?.folha_pagamento_em_aberto > 0 ? (
                    <Badge color="danger" rounded>
                      {cards?.folha_pagamento_em_aberto}
                    </Badge>
                  ) : (
                    <Badge color="success" rounded>
                      ✔
                    </Badge>
                  )
                ) : (
                  ""
                )}
              </>
            </TabButton>
          </TabList>
          <TabContent>
            <TabPane id="impostos" ativo={tabAtiva === "impostos"}>
              <ImpostosDataTable
                linhas={impostos}
                togNovoImpostoModal={togNovoImpostoModal}
                visualizarDocumento={visualizarDocumento}
                togPagarImpostoModal={togPagarImpostoModal}
                excluirImposto={excluirImposto}
                togSubstituirImpostoModal={togSubstituirImpostoModal}
                togSolicitarRecalculoModal={togSolicitarRecalculoModal}
                cancelarRecalculo={cancelarRecalculo}
                toghistoricoModal={toghistoricoModal}
                downloadDocumento={downloadDocumento}
              />
            </TabPane>
            <TabPane id="mensalidade" ativo={tabAtiva === "honorarios"}>
              <MensalidadeDataTable
                linhas={honorarios}
                visualizarDocumento={visualizarDocumento}
                togSubstituirHonorarioModal={togSubstituirHonorarioModal}
              />
            </TabPane>
            <TabPane id="proLabore" ativo={tabAtiva === "prolabore"}>
              <ProLaboreDataTable
                linhas={proLabores}
                togNovoProLaboreModal={togNovoProLaboreModal}
                visualizarDocumento={visualizarDocumento}
                excluirProLabore={excluirProLabore}
                pagarProLabore={pagarProLabore}
                downloadDocumento={downloadDocumento}
                checkboxesHook={{
                  checkboxesMarcados: checkboxesMarcadosPL,
                  setCheckboxesMarcados: setCheckboxesMarcadosPL,
                }}
                togDownloadMassaModal={togDownloadMassaModal}
              />
            </TabPane>
            <TabPane
              id="folhaDePagamento"
              ativo={tabAtiva === "folhapagamento"}
            >
              <FolhaPagamentoDataTable
                linhas={folhaPagamento}
                togNovaFolhaPagamentoModal={togNovaFolhaPagamentoModal}
                visualizarDocumento={visualizarDocumento}
                excluirFolhaPagamento={excluirFolhaPagamento}
                pagarFolhaPagamento={pagarFolhaPagamento}
                downloadDocumento={downloadDocumento}
                checkboxesHook={{
                  checkboxesMarcados: checkboxesMarcadosFP,
                  setCheckboxesMarcados: setCheckboxesMarcadosFP,
                }}
                togDownloadMassaModal={togDownloadMassaModal}
              />
            </TabPane>
          </TabContent>
        </Card>
        {tabAtiva === "impostos" ? (
          <Card>
            <h4 className="card-title">Impostos atrasados</h4>
            <br />
            <ImpostosDataTable
              linhas={impostosAtrasados}
              togNovoImpostoModal={togNovoImpostoModal}
              visualizarDocumento={visualizarDocumento}
              togPagarImpostoModal={togPagarImpostoModal}
              excluirImposto={excluirImposto}
              togSubstituirImpostoModal={togSubstituirImpostoModal}
              togSolicitarRecalculoModal={togSolicitarRecalculoModal}
              cancelarRecalculo={cancelarRecalculo}
              toghistoricoModal={toghistoricoModal}
              downloadDocumento={downloadDocumento}
              noButton
            />
          </Card>
        ) : null}
      </div>
      <NovoImpostoModal
        modalHook={{ novoImpostoModal, setNovoImpostoModal }}
        valuesHook={{ values, setValues }}
        salvaImposto={salvaImposto}
        getDadosArquivo={getDadosArquivo}
        anoInicial={anoInicial}
        anoFinal={anoFinal}
      />
      <NovoProLaboreModal
        modalHook={{ novoProLaboreModal, setNovoProLaboreModal }}
        valuesHook={{ values, setValues }}
        socios={socios}
        salvaProlabore={salvaProlabore}
        anoInicial={anoInicial}
        anoFinal={anoFinal}
      />
      <NovaFolhaPagamentoModal
        modalHook={{ novaFolhaPagamentoModal, setNovaFolhaPagamentoModal }}
        valuesHook={{ values, setValues }}
        colaboradores={colaboradores}
        salvaFolhaPagamento={salvaFolhaPagamento}
        anoInicial={anoInicial}
        anoFinal={anoFinal}
      />
      <DocumentoModal
        modalHook={{ documentoModal, setDocumentoModal }}
        documento={values?.documento}
      />
      <PagarImpostoModal
        modalHook={{ pagarImpostoModal, setPagarImpostoModal }}
        valuesHook={{ values, setValues }}
        pagarImposto={pagarImposto}
        cancelarPagamentoImposto={cancelarPagamentoImposto}
      />
      <SubstituirImpostoModal
        modalHook={{ substituirImpostoModal, setSubstituirImpostoModal }}
        valuesHook={{ values, setValues }}
        substituirImposto={substituirImposto}
      />
      <SubstituirHonorarioModal
        modalHook={{ substituirHonorarioModal, setSubstituirHonorarioModal }}
        valuesHook={{ values, setValues }}
        substituirHonorario={substituirHonorario}
      />
      <SolicitarRecalculoModal
        modalHook={{ solicitarRecalculoModal, setSolicitarRecalculoModal }}
        valuesHook={{ values, setValues }}
        solicitarRecalculo={solicitarRecalculo}
        solicitarRecalculoAutomatico={solicitarRecalculoAutomatico}
      />
      <HistoricoModal
        modalHook={{ historicoModal, setHistoricoModal }}
        valuesHook={{ values, setValues }}
        downloadDocumento={downloadDocumento}
        excluirDocumento={excluirDocumento}
      />
      <DownloadMassaModal
        DownloadModalHook={{ downloadMassaModal, setDownloadMassaModal }}
        valuesHook={{ values, setValues }}
        downloadMassa={downloadMassa}
      />
    </>
  );
}

export default ContasAPagar;
